(function () {
  'use strict';
  if (window.HealthyEventRequest) return;
  const key = 'healthy-italia:event-lead:v1';
  async function post(root, path, payload) {
    const base = (root.dataset.apiBase || '').replace(/\/$/, '');
    if (!base) throw new Error('Unable to save your request. Please contact Healthy Italia.');
    const response = await fetch(base + '/api/public/event-requests' + path, {
      method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(payload),
      signal: AbortSignal.timeout(15000)
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Unable to save your request. Please retry.');
    return data;
  }
  async function contact(root) {
    const lead = JSON.parse(sessionStorage.getItem(key));
    if (!lead || !lead.captured || Date.now()-lead.savedAt >= 7200000) throw new Error('Please return to Step 1.');
    if (!lead.requestToken) {
      lead.requestToken = crypto.randomUUID();
      sessionStorage.setItem(key, JSON.stringify(lead));
    }
    if (!lead.requestId) {
      const result = await post(root, '', {token:lead.requestToken,name:lead.name,email:lead.email,phone:lead.phone});
      lead.requestId = result.id;
      sessionStorage.setItem(key, JSON.stringify(lead));
    }
    return lead;
  }
  let lastRevision = 0;
  window.HealthyEventRequest = {
    contact,
    async quote(root, quote) {
      const lead = await contact(root);
      lastRevision = Math.max(Date.now(), lastRevision+1);
      return post(root, '/quote', {token:lead.requestToken,revision:lastRevision,quote});
    }
  };
})();
